
































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import RentalBookingJson, { defaultRentalBookingJson } from "../../shared/RentalBookingJson";
import { RentalItemInfoJson } from "../../shared/RentalItemJson";
import SettingsJson from "../../shared/SettingsJson";
import PriceUtils from "../../shared/PriceUtils";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalConditionJson, validateUniqueRentalConditionTitle } from "../../shared/RentalConditionJson";
import RentalItemJson from "../../shared/RentalItemJson";
import RentalConditionJson, { defaultRentalConditionJson } from "../../shared/RentalConditionJson";

type keysForCachedPrices = {
  [key in keyof Pick<RentalConditionJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "RentalBookingAdditionalConditionSelect",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    productIndex: Number,
    rentalItem: Object,
    data: Array as PropType<RentalConditionJson[]>,
    editable: Boolean,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      RentalBookingDefaultData: defaultRentalBookingJson(),
      supportsDatePicker: false,
      UserPermissionRank: UserPermissionRank,
      PriceUtils: PriceUtils,
      defaultRentalConditionJson: defaultRentalConditionJson,
      settings: null as SettingsJson | null,
      details: null as RentalConditionJson[] | null,
      cachedPrices: [] as keysForCachedPrices[],
      selectedCondition: null as RentalConditionJson | null,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      toValidate: {} as any,
      compValidation: [null] as (ValidationResult<RentalConditionJson> | null)[],
      frontendValidations: [] as { title: boolean }[],
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    init() {
      this.loadSettings();
      this.details = [...this.data];

      this.setCachedData();
    },

    async loadSettings() {
      if (this.restClient != null) {
        this.settings = null;

        try {
          this.settings = await this.restClient.getSettings();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    setCachedData() {
      this.setCachedPrices();

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    setAdditionalRentalCondition() {
      if (this.details != null && this.selectedCondition != null) {
        this.details.push(this.selectedCondition);
      }

      this.cachedPrices = [];
      this.setCachedPrices();
      this.selectedCondition = null;

      this.checkFrontendValidations();
    },

    //START set cached data

    setCachedPrices() {
      if (this.details != null) {
        for (let i = 0; i < this.details.length; i++) {
          let prices = {
            price: "0,00",
            cancellationFee: "0,00",
          } as keysForCachedPrices;

          let k = prices;
          let j: keyof typeof k;

          for (j in prices) {
            prices[j] = this.getFormatPrice(this.details[i][j]);
          }

          this.cachedPrices.push(prices);
        }
      }
    },

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.compValidation[key] = validateRentalConditionJson(this.details[key]);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START frontend Validation

    validateUniqueTitle(index: number) {
      if (this.details != null) {
        if (!(index in this.frontendValidations)) {
          this.frontendValidations[index] = { title: false };
        }

        this.frontendValidations[index].title = validateUniqueRentalConditionTitle(
          this.details[index].title,
          this.details
        );
      }
    },

    checkFrontendValidations() {
      let check = true;

      for (let frontendValidation of this.frontendValidations) {
        let k = frontendValidation;
        let i: keyof typeof k;
        for (i in frontendValidation) {
          if (frontendValidation[i] == true) {
            check = false;
            break;
          }
        }
      }

      return check;
    },

    //END frontend validation

    deleteAdditionalRentalConditions(conditionIndex: number) {
      if (this.details != null) {
        this.details.splice(conditionIndex, 1);
        this.cachedPrices.splice(conditionIndex, 1);

        delete this.toValidate[conditionIndex];
      }
    },

    //START set input data (where data be cached)

    formatAndSetCachedPrice(index: number, key: keyof keysForCachedPrices) {
      if (index != null && this.details != null) {
        let price = this.cachedPrices[index][key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[index][key] = price;
        this.details[index][key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data (where data be cached)

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
          this.$emit("change", this.details);
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    filteredAdditionalRentalConditions(): RentalConditionJson[] | null {
      let filteredAdditionalRentalConditions: RentalConditionJson[] | null = null;

      if (this.rentalItem != null && this.details != null) {
        filteredAdditionalRentalConditions = this.rentalItem.additionalRentalConditions.filter(
          (i: RentalConditionJson) => !this.details?.find((j: RentalConditionJson) => j.title == i.title)
        );
      }

      return filteredAdditionalRentalConditions;
    },
  },
});
